import {
    MERCHANTHISTORY_SUCCESS,
    MERCHANTHISTORY_FAILED,
    RESET_MERCHANTHISTORY,
    LOADING_MERCHANTHISTORY,
    NETWORK_ERROR_MERCHANTHISTORY
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetMerchantHistory = () => {
    return { type: RESET_MERCHANTHISTORY };
};

const merchantHistory = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_MERCHANTHISTORY });
    await partnerServices
        .post("modifyAndHistoryList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(merchantHistorysuccess(res.data));
                    break;
                default:
                    dispatch(merchantHistoryFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_MERCHANTHISTORY,
                payload: err
            });
        });
};
function merchantHistorysuccess(data) {
    return {
        type: MERCHANTHISTORY_SUCCESS,
        payload: data
    };
}
function merchantHistoryFailed(data) {
    return {
        type: MERCHANTHISTORY_FAILED,
        payload: data
    };
}

export { resetMerchantHistory, merchantHistory };
